import { getCurrentUser } from "./auth";

export const getUserPrimaryRole = () => {
  const userDetails = getCurrentUser();
  return userDetails?.primaryRoleName;
};

export const isUserL9Role = () => {
  const userDetails = getCurrentUser();
  if (userDetails?.primaryRoleName === "L9") return true;
  if (Array.isArray(userDetails?.roles)) {
    return userDetails.roles.some((r) => r.name === "L9" || r === "L9");
  }
  return false;
};
